(() => {
  const hero = document.querySelector('[data-hce-luxury-hero]');
  const rail = document.querySelector('[data-hce-collection-rail]');
  const header = document.getElementById('SiteHeader');
  const headerInner = document.getElementById('SiteHeaderInner');
  if (!hero) return;

  const heroPicture = hero.querySelector('.hce-hero__media picture');
  const heroImage = hero.querySelector('.hce-hero__media img');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  let ticking = false;
  let lastHeaderFade = 0;

  const headerColorTargets = header ? Array.from(header.querySelectorAll(
    '.header-mobile-logo, .header-desktop-logo, .hdr-toolbar-item, .hdr-item-language-selector, .header-bar--shopping-tools, .header-bar--shopping-tools a, .header-bar--shopping-tools button, .hdr-nav-desktop, .hdr-nav-desktop a'
  )) : [];
  const standardLogos = header ? Array.from(header.querySelectorAll('.header--logo-std')) : [];
  const invertedLogos = header ? Array.from(header.querySelectorAll('.header--logo-inverted')) : [];
  const menuLines = header ? Array.from(header.querySelectorAll('.menu-line')) : [];

  const configureHeroMedia = () => {
    if (heroPicture) {
      heroPicture.style.inset = '0';
      heroPicture.style.overflow = 'hidden';
    }
    if (!heroImage) return;

    heroImage.style.position = 'absolute';
    heroImage.style.left = '0';
    heroImage.style.width = '100%';
    heroImage.style.height = '124%';
    heroImage.style.top = '-12%';
    heroImage.style.maxWidth = 'none';
    heroImage.style.transformOrigin = 'center center';
    heroImage.style.willChange = 'transform';
    heroImage.style.transition = 'none';
  };

  const configureLogoLayers = () => {
    if (!header) return;
    header.querySelectorAll('.header--logo').forEach((logo) => {
      logo.style.position = 'relative';
      const anchor = logo.querySelector('a');
      if (anchor) {
        anchor.style.position = 'relative';
        anchor.style.display = 'block';
        anchor.style.width = '100%';
        anchor.style.height = '100%';
      }
      logo.querySelectorAll('.header--logo-std, .header--logo-inverted').forEach((layer) => {
        layer.style.setProperty('display', 'block', 'important');
        layer.style.position = 'absolute';
        layer.style.inset = '0';
        layer.style.width = '100%';
        layer.style.height = '100%';
        layer.style.transition = 'none';
      });
    });
  };

  const applyHeaderVisual = (fade) => {
    if (!headerInner) return;
    const effectiveFade = headerInner.classList.contains('hovered') ? 1 : fade;
    const ink = Math.round(255 - (232 * effectiveFade));
    const inkColor = `rgb(${ink}, ${ink}, ${ink})`;

    headerInner.style.setProperty('background', `rgba(255, 255, 255, ${effectiveFade.toFixed(3)})`, 'important');
    headerInner.style.setProperty('color', inkColor, 'important');
    headerInner.style.setProperty('border-bottom', `1px solid rgba(23, 21, 18, ${(0.15 * effectiveFade).toFixed(3)})`, 'important');
    headerInner.style.setProperty('box-shadow', 'none', 'important');

    headerColorTargets.forEach((node) => node.style.setProperty('color', inkColor, 'important'));
    standardLogos.forEach((node) => {
      node.style.setProperty('display', 'block', 'important');
      node.style.setProperty('opacity', effectiveFade.toFixed(3), 'important');
    });
    invertedLogos.forEach((node) => {
      node.style.setProperty('display', 'block', 'important');
      node.style.setProperty('opacity', (1 - effectiveFade).toFixed(3), 'important');
    });
    menuLines.forEach((line) => {
      line.style.setProperty('border-top-color', inkColor, 'important');
      if (line.closest('.menu-icon-style-three_dots')) line.style.setProperty('background', inkColor, 'important');
    });
  };

  configureHeroMedia();
  configureLogoLayers();

  if (rail) {
    rail.style.setProperty('background', '#f6f5f2', 'important');
    rail.style.setProperty('border-top', '1px solid rgba(40, 48, 82, .12)', 'important');
    rail.style.setProperty('border-bottom', '1px solid rgba(40, 48, 82, .18)', 'important');
    rail.style.setProperty('box-shadow', '0 8px 24px rgba(19, 22, 33, .035)', 'important');
  }

  let cue = hero.querySelector('.hce-scroll-cue');
  if (!cue) {
    cue = document.createElement('div');
    cue.className = 'hce-scroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.textContent = 'SCROLL TO DISCOVER ↓';
    hero.appendChild(cue);
  }

  if (!document.getElementById('hce-home-runtime-style')) {
    const style = document.createElement('style');
    style.id = 'hce-home-runtime-style';
    style.textContent = `
      .lx-template--index .hce-luxury-hero .hce-scroll-cue {
        position: absolute;
        z-index: 4;
        left: 50%;
        bottom: 28px;
        transform: translateX(-50%);
        color: rgba(255,255,255,.94);
        font-family: var(--font-accent-family, sans-serif);
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: .12em;
        white-space: nowrap;
        pointer-events: none;
        text-shadow: 0 1px 12px rgba(0,0,0,.68);
        transition: opacity .18s ease;
      }
      @media (max-width: 749px) {
        .lx-template--index .hce-luxury-hero .hce-scroll-cue {
          bottom: 20px;
          font-size: 11.5px;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .lx-template--index .hce-luxury-hero .hce-scroll-cue { transition: none; }
      }
    `;
    document.head.appendChild(style);
  }

  const update = () => {
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const heroRect = hero.getBoundingClientRect();
    const heroHeight = Math.max(hero.offsetHeight, 1);
    const transitionDistance = Math.max(heroHeight - headerBottom, heroHeight * 0.35);
    const transitionProgress = clamp(-heroRect.top / transitionDistance, 0, 1);
    const heroProgress = clamp(-heroRect.top / heroHeight, 0, 1);

    // The header starts turning white only through the final 20% of the hero.
    lastHeaderFade = clamp((transitionProgress - 0.8) / 0.2, 0, 1);
    applyHeaderVisual(lastHeaderFade);

    // The collection navigation arrives exactly when the fade has completed.
    document.body.classList.toggle('hce-home-scrolled', transitionProgress >= 0.999);
    if (rail && header) rail.style.setProperty('--hce-collection-rail-top', `${Math.round(headerBottom)}px`);

    if (cue) cue.style.opacity = `${(0.94 * clamp(1 - heroProgress * 2.5, 0, 1)).toFixed(2)}`;

    if (heroImage) {
      if (reducedMotion.matches) {
        heroImage.style.transform = 'translate3d(0, 0, 0)';
      } else {
        const offset = heroHeight * 0.12 * transitionProgress;
        heroImage.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
      }
    }

    ticking = false;
  };

  const requestUpdate = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  if (headerInner) {
    new MutationObserver(() => applyHeaderVisual(lastHeaderFade)).observe(headerInner, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', () => {
    configureHeroMedia();
    configureLogoLayers();
    requestUpdate();
  });
  reducedMotion.addEventListener?.('change', requestUpdate);
  requestUpdate();
})();
